import { ConfirmationModal } from '@issuemanager/apps/client/components';
import { useAttachmentsContext } from '@issuemanager/apps/client/contexts';
import React from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onAccept: () => void;
  onClose: () => void;
  attachmentsField: React.JSX.Element;
  hasAttachments: boolean;
};

export function CommentAttachmentsModal({
  open,
  onClose,
  attachmentsField,
  onAccept,
  hasAttachments,
}: Props) {
  const { t } = useTranslation('issue');
  const { isLoading: isUploadAttachmentsLoading } = useAttachmentsContext();

  const disabledAcceptBtn = isUploadAttachmentsLoading || !hasAttachments;

  return (
    <ConfirmationModal
      isOpen={open}
      title={t('comment.attachments.modal.title')}
      description={attachmentsField}
      acceptButtonProps={{
        text: t('comment.attachments.modal.accept'),
        disabled: disabledAcceptBtn,
      }}
      cancelButtonProps={{
        text: t('comment.attachments.modal.cancel'),
        variant: 'text',
        disabled: isUploadAttachmentsLoading,
      }}
      onAccept={onAccept}
      onCancel={onClose}
      swapButtons
    />
  );
}
